<template>
  <div
    class="Re_form_group No-margin-bottom"
    :class="{'error': hasErrors}"
  >
    <p class="Input-container">
      <label
        class="Re_form_label form_label"
        v-if="label"
      >
        {{ label }}
      </label>
      <input
        class="Re_form_control"
        :class="{'form_control': top}"
        :value="value"
        :text="text"
        v-bind="$attrs"
        v-on="listeners"
        :autocomplete="autocomplete"
        :type="$attrs.type || 'text'"
      >
      <span class="TextInputButton">
        <a
          :disabled="buttonDisabled"
          :class="buttonClass"
          href="javascript:void(0);"
          @click.prevent="apply"
        >
          <span :class="{'disabled': !value}">
            {{ buttonLabel }}
          </span>
        </a>
      </span>
    </p>
    <p class="tip-error" v-for="(error, index) in errors" :key="index">{{ error }}</p>
    <p class="Tip" v-if="tips">{{ tips }}</p>
  </div>
</template>

<script>
  import InputMixin from './input'
  import ValidationMixin from './validation'

  export default {
    mixins: [InputMixin, ValidationMixin],

    props: {
      buttonLabel: {
        type: String,
        default: 'Apply'
      },
      buttonDisabled: {
        type: Boolean,
        default: false
      },
      buttonClass: {
        type: String,
        default: ''
      }
    },

    methods: {
      apply () {
        if (this.value) {
          this.$emit('apply', this.value)
        }
      }
    }
  }
</script>

<style lang="scss">
  input:required {
    box-shadow: none;
  }

  .Re_form_group.No-margin-bottom {
    margin-bottom: 0;
  }

  .Input-container {
    display: flex;
    position: relative;

    .TextInputButton {
      display: flex;
      position: absolute;
      right: .15rem;
      top: 67%;
      transform: translateY(-67%);
      cursor: pointer;

      .disabled {
        color: #c4c4c4;
        line-height: .2rem;
        font-size: .14rem;
        cursor: default;
      }
    }
  }

  .Tip {
    font-size: .12rem;
    color: $gray;
  }

  input::-ms-reveal,
  ::-ms-clear {
    display: none;
  }
</style>
